
export function initOfficeMock() {
    window['Office'] = {
        ...window['Office'],
        context: {
            displayLanguage: 'en-US',
            diagnostics: {
                host: "Outlook",
                platform: "OfficeOnline",
                version: "16.0.10908.10000",
            },
            platform: "OfficeOnline",
            touchEnabled: false,
            ui: {
                closeContainer: (...rest) => noop('closeContainer', rest),
                displayDialogAsync: (...rest) => noop('displayDialogAsync', rest),
                messageParent: (...rest) => noop('messageParent', rest),
            },
            requirements: {
                isSetSupported: () => true
            },
            roamingSettings: {
                get: noop,
                set: noop,
                saveAsync: (cbk: (args: any) => void) => { cbk({ status: "succeeded" }); },
            },
            mailbox: {
                diagnostics: {
                    hostName: "OutlookWebApp",
                    hostVersion: "2018112401.04"
                },
                addHandlerAsync: (...rest) => noop('addHandlerAsync', rest),
                displayNewAppointmentForm: (...rest) => noop('displayNewAppointmentForm', rest),
                displayNewMessageForm: (...rest) => noop('displayNewMessageForm', rest),
                ewsUrl: "https://outlook.office365.com/EWS/Exchange.asmx",
                convertToRestId: (id) => id,
                makeEwsRequestAsync: (ewsRequest: string, cbk: (result) => void) => {
                    if (ewsRequest.indexOf('<GetItem') > 0) {
                        cbk({
                            status: 'succeeded',
                            value: `<?xml version="1.0" encoding="utf-8"?><s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/"><s:Header><h:ServerVersionInfo MajorVersion="15" MinorVersion="20" MajorBuildNumber="1404" MinorBuildNumber="25" Version="V2018_01_08" xmlns:h="http://schemas.microsoft.com/exchange/services/2006/types" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"/></s:Header><s:Body><m:GetItemResponse xmlns:m="http://schemas.microsoft.com/exchange/services/2006/messages" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:t="http://schemas.microsoft.com/exchange/services/2006/types"><m:ResponseMessages><m:GetItemResponseMessage ResponseClass="Success"><m:ResponseCode>NoError</m:ResponseCode><m:Items><t:Message><t:ItemId Id="AQMkAGE4YzVhY2QwLTNlNmQtNGRjYi05NDc4LWExZGE1MWFjMmU1ZgBGAAAD4z4nYxoyr0+gdzJYdKHfAwcAByJ6RbKFSEuZrR/g1fIY6gAAAw4AAAAHInpFsoVIS5mtH+DV8hjqAAT87Kf2AAAA" ChangeKey="CQAAABYAAAAHInpFsoVIS5mtH+DV8hjqAAUCxar9"/><t:Subject>Re: [Atlassian Marketplace] Feedback for Outlook Calendars for Confluence</t:Subject><t:ExtendedProperty><t:ExtendedFieldURI PropertyTag="0x3013" PropertyType="Binary"/><t:Value>Mna4JcGE6E2LDyTiEHpG3w==</t:Value></t:ExtendedProperty><t:ExtendedProperty><t:ExtendedFieldURI PropertyTag="0x1039" PropertyType="String"/><t:Value>&lt;EogqqSIHRyOAVrTyJrs2Mw@ismtpd0001p1las1.sendgrid.net&gt;,&lt;VI1PR05MB4861E243DCBC8DAB238F306D9CD20@VI1PR05MB4861.eurprd05.prod.outlook.com&gt;</t:Value></t:ExtendedProperty><t:ExtendedProperty><t:ExtendedFieldURI PropertyTag="0x1a" PropertyType="String"/><t:Value>IPM.Note</t:Value></t:ExtendedProperty></t:Message></m:Items></m:GetItemResponseMessage></m:ResponseMessages></m:GetItemResponse></s:Body></s:Envelope>`
                        });
                    }
                },
                userProfile: {
                    accountType: "office365",
                    displayName: "Andreas Schmidt",
                    emailAddress: "andreas.schmidt@yasoon.com",
                    timeZone: "W. Europe Standard Time"
                },

                item: {
                    attachments: [],
                    body: {
                        getAsync: (type: any, cbk: (args: any) => void) => { cbk({ value: 'Haha body, https://yasoon.atlassian.net/browse/DEMO-1107' }); }
                    },
                    cc: [],
                    conversationId: "AAQkAGE4YzVhY2QwLTNlNmQtNGRjYi05NDc4LWExZGE1MWFjMmU1ZgAQADJ2uCXBhOhNiw8k4hB6Rt8=",
                    dateTimeCreated: new Date(),
                    dateTimeModified: new Date(),
                    from: {
                        displayName: 'Tobi',
                        emailAddress: 'tobias.viehweger@yasoon.com'
                    },
                    internetMessageId: '<DB8PR05MB585172DCE11F39D25201F566ECD20@DB8PR05MB5851.eurprd05.prod.outlook.com>',
                    itemClass: "IPM.Note",
                    itemId: "AQMkAGE4YzVhY2QwLTNlNmQtNGRjYi05NDc4LWExZGE1MWFjMmU1ZgBGAAAD4z4nYxoyr0+gdzJYdKHfAwcAByJ6RbKFSEuZrR/g1fIY6gAAAw4AAAAHInpFsoVIS5mtH+DV8hjqAAT87Kf2AAAA",
                    itemType: 'message',
                    normalizedSubject: 'Subject',
                    sender: {
                        displayName: 'Tobi',
                        emailAddress: 'tobias.viehweger@yasoon.com'
                    },
                    subject: 'Subject',
                    to: [{
                        displayName: 'Andy',
                        emailAddress: 'andreas.schmidt@yasoon.com'
                    }]
                }
            }
        },
        MailboxEnums: {
            RestVersion: {
                Beta: "beta",
                v1_0: "v1.0",
                v2_0: "v2.0"
            },
            ItemType: {
                Message: "message",
                Appointment: "appointment"
            }
        },
        InitializationReason: {
            DocumentOpened: 'documentOpened'
        }
    } as any;
}

function noop(name: string, args: any) {
    console.log('Call method ' + name, args);
}
